import { signal } from "@preact/signals-react";

import { EllipsisVerticalIcon, XMarkIcon } from "components/Icons";
import Popover from "componentsv2/widgets/Popover";

const OptionsColumn = ({ column, actions, filterColumn, userFilter, setUserFilter, currentUserId, columnKey }) => {
  const currentFilter = userFilter?.[columnKey];

  function handleFilterByUser() {
    if (currentFilter === currentUserId) {
      setUserFilter((prev) => {
        const newFilter = { ...prev };
        delete newFilter[columnKey];
        return newFilter;
      });
    } else {
      setUserFilter((prev) => ({
        ...prev,
        [columnKey]: currentUserId,
      }));
    }
    show.value = false;
  }

  function handleClearFilter() {
    setUserFilter((prev) => {
      const newFilter = { ...prev };
      delete newFilter[columnKey];
      return newFilter;
    });
    show.value = false;
  }

  const show = signal(false);
  return (
    <div className="absolute left-0 top-1/2 -translate-y-1/2 max-w-max">
      <button
        type="button"
        className="cursor-pointer"
        onClick={() => (show.value = !show.value)}
      >
        <EllipsisVerticalIcon className="h-5 text-gray-500 fill-current" />
      </button>
      <Popover
        show={show}
        className={"p-0! min-w-max overflow-hidden"}
        position="right"
      >
        <ul className="max-w-max!  text-gray-800 cursor-pointer">
          <li
            className="hover:bg-gray-800 px-4 py-2 hover:text-white"
            onClick={handleFilterByUser}
          >
            {currentFilter === currentUserId ? "✓ Mis órdenes" : "Filtrar mis órdenes"}
          </li>
          {currentFilter && (
            <li
              className="hover:bg-red-600 px-4 py-2 hover:text-white flex items-center gap-2"
              onClick={handleClearFilter}
            >
              <XMarkIcon className="h-4 w-4" />
              Limpiar filtro
            </li>
          )}
        </ul>
      </Popover>
    </div>
  );
};

export default OptionsColumn;
